import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable, of } from 'rxjs';

import { DistributionComponent } from '../../Targeting/components/Distribution/distribution.component';
import { DistributionService } from '../../../Common/TargetingShared/services/distribution.service';
import { DiscoverRoutingService } from '../../DiscoverRouter/services/discover-routing.service';
import { DiscoverRouteTypeEnum } from '../../DiscoverRouter/enums/discover-route-type.enum';

@Injectable()
export class DistributionDeactivateGuard implements CanDeactivate<DistributionComponent> {
    constructor(
        public distributionService: DistributionService,
        public discoverRoutingService: DiscoverRoutingService
    ) {}

    canDeactivate(component: DistributionComponent): Observable<boolean> {
        const destinationRoute = this.discoverRoutingService.getNextRoute();

        if (
            destinationRoute
            && destinationRoute.type === DiscoverRouteTypeEnum.newDistribution
            && !destinationRoute.value
        ) {
            // New distribution case, the amplify dialog checks for unsaved before it opens, when navigation happens it's already been asked, don't ask again
            return of(true);
        }

        return this.distributionService.showExitDialog();
    }
}
